import React from "react";

const DisableButton = ({
  title = "حفظ التعديلات",
  className = "btn-save d-inline mt-2 bg-white border-0 text-black-50",
}) => {
  return (
    <button
      disabled
      className={className}
      style={{
        userSelect: "none",
        cursor: "auto",
      }}
    >
      {title}
    </button>
  );
};

export default DisableButton;
